import React, { useState } from 'react';
import './Modal.css';
import { useTranslation } from 'react-i18next';
import { ASSIGNABLE_ROLES } from '../../../utils/rolesMatrix';

export default function InviteMemberModal({ onClose, onInvite }) {
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('member');
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('organization');
  const { t: tc } = useTranslation('common');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim() || !email.includes('@')) {
      alert(t('inviteModal.emailRequired'));
      return;
    }

    setLoading(true);
    try {
      await onInvite(email.trim(), role);
      // Modal will be closed by parent component on success
    } catch (error) {
      console.error('Error inviting member:', error);
      alert(t('errors.sendInvitation') + (error.message || t('errors.unknownError')));
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t('inviteModal.title')}</h2>
          <button
            className="modal-close"
            onClick={onClose}
            disabled={loading}
            aria-label={tc('close')}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="member-email">{t('inviteModal.emailLabel')}</label>
            <input
              id="member-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('inviteModal.emailPlaceholder')}
              required
              disabled={loading}
              autoFocus
            />
            <small className="help-text">
              {t('inviteModal.emailHelp')}
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="member-role">{t('inviteModal.roleLabel')}</label>
            <select
              id="member-role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              disabled={loading}
            >
              {/* Roles asignables desde la fuente única (rolesMatrix). viewer
                  queda retirado del catálogo para el lanzamiento. */}
              {ASSIGNABLE_ROLES.map((r) => (
                <option key={r} value={r}>
                  {t(`inviteModal.role${r.charAt(0).toUpperCase()}${r.slice(1)}`)}
                </option>
              ))}
            </select>
            <small className="help-text">
              {t('inviteModal.roleHelp')}
            </small>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              {tc('cancel')}
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? tc('sending') : t('inviteModal.sendInvitation')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
